import React, { useState, useEffect } from 'react';

const ConNoteList = (props) => {
  const taskId = props.taskId;
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNotes = async () => {
      try {
        const response = await fetch(`/api/task/${taskId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch task data');
        }
        const taskData = await response.json();
        setNotes(taskData.notes || []);
      } catch (error) {
        console.error('Error fetching task data:', error);
        setError('Failed to load task data');
      } finally {
        setLoading(false);
      }
    };
    if (taskId) {
      fetchNotes();
    }
  }, [taskId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  // Sort notes by date in descending order (newest first)
  const sortedNotes = [...notes].sort((a, b) => {
    if (!a.date && !b.date) return 0;
    if (!a.date) return 1;
    if (!b.date) return -1;
    return new Date(b.date) - new Date(a.date);
  });

  return (
    <div style={{ 
      maxHeight: '80vh', 
      minWidth: 350, 
      maxWidth: 600, 
      overflowY: 'auto', 
      padding: 24, 
      position: 'relative', 
      background: 'white', 
      borderRadius: 12, 
      boxShadow: '0 4px 24px rgba(0,0,0,0.12)' 
    }}>
      {props.onClose && (
        <button
          onClick={props.onClose}
          style={{ 
            position: 'absolute', 
            top: 12, 
            right: 16, 
            fontSize: 24, 
            color: '#888', 
            background: 'none', 
            border: 'none', 
            cursor: 'pointer', 
            zIndex: 10 
          }}
          aria-label="Close"
        >×</button>
      )}
      <h2 className="text-2xl font-bold mb-4">Task Notes</h2>
      <div className="space-y-4">
        {sortedNotes.map((note, index) => (
          <div key={index} className="bg-white p-4 rounded-lg shadow">
            <div className="flex justify-between items-start">
              <div>
                <p className="text-gray-600 text-sm">
                  {note.date ? new Date(note.date).toLocaleString("en-CA", { 
                    timeZone: "America/Toronto", 
                    year: "numeric", 
                    month: "2-digit", 
                    day: "2-digit", 
                    hour: "2-digit", 
                    minute: "2-digit" 
                  }) : "-"}
                  {note.user_name || note.user_id ? ` by ${note.user_name || note.user_id}` : ""}
                </p>
                <p className="mt-2">{note.text}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConNoteList;